import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";


import SignService from "../services/sign.service";


const list = {
  list: [],
  pageSize: 25,
  page: 0,
  total: 0,
  nextPage: 0
};

export const getSignImages= createAsyncThunk(
  "signImages/getImages",
  async ({search}, thunkAPI) => {
    try {

      const data = await SignService.getSignImages(search);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getSignImage = createAsyncThunk(
  "signImages/getImage",
  async (imageID, thunkAPI) => {
    try {
      const data = await SignService.getSignImage(imageID);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);


export const updateSignImage = createAsyncThunk(
  "signImages/updateImage",
  async ( {image},thunkAPI) => {
    try {
      const data = await SignService.updateSignImage(image);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const createSignImage = createAsyncThunk(
  "signImages/createSignImage",
  async ( {image},thunkAPI) => {
    try {
      const data = await SignService.createSignImage(image);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);


const initialState = { data: list, loading: false};

const signImageSlice = createSlice({
  name: "signImage",
  initialState,
  extraReducers: {

    [getSignImages.pending]: (state, action) => {
      state.loading = true;
    },
    [getSignImages.fulfilled]: (state, action) => {

      state.data = action.payload.data; 
      state.loading = false;
    },
    [getSignImages.rejected]: (state, action) => {
      state.data = list
      state.loading = false;
    },

    [getSignImage.pending]: (state, action) => {
      state.loading = true;
    },
    [getSignImage.fulfilled]: (state, action) => {

      //is sign in list if so change it
      //else push it in

      let images = state.data.list;
      let thisImage = images.find((image) => image.id === action.payload.data.id)

      if(thisImage){
        Object.assign(thisImage,action.payload.data)
      }else{
        state.data.list.push(action.payload.data)
        state.data.total ++;
      }

      state.loading = false;
    },
    [getSignImage.rejected]: (state, action) => {
      state.data = list
      state.loading = false;
    },
    
    [updateSignImage.fulfilled]: (state, action) => {

      let images = state.data.list;
      let thisImage = images.find((image) => image.id === action.payload.data.id)
      Object.assign(thisImage,action.payload.data)

    },

  },
});


const { reducer } = signImageSlice;
export default reducer;